import Vue from 'vue'
export default new Vue


// WEBPACK FOOTER //
// ./plugins/bus.js